<!-- Display a preloader in the form of a progress bar -->
<div *ngIf="uiService.preloaderConfig.showProgressBar" class="preloader-container">
  <div class="progress">
    <div class="progress--bar"></div>
  </div>
</div>
